import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { DeleteBankAccountsMutationResponse, DeleteBankAccountsQueryParams, DeleteBankAccounts400, DeleteBankAccounts500 } from "../types/DeleteBankAccounts";

/**
 * @summary Удалить банковский счета организации
 * @link /api/lk/organization/bank-account
 */

export function useDeleteBankAccounts <TData = DeleteBankAccountsMutationResponse, TError = DeleteBankAccounts400 | DeleteBankAccounts500>(params: DeleteBankAccountsQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, void>,
          client?: Partial<Parameters<typeof client<TData, TError, void>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, void> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, void>({
    mutationFn: () => {
      
      return client<TData, TError, void>({
        method: "delete",
        url: `/api/lk/organization/bank-account`,
        
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
